(() => {
  const KEY = 'lb_recent_v1';
  const MAX = 8;
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} };
  let current = null;
  const cur = document.getElementById('LbRecentCurrent');
  if (cur && !window.__lbRecentSaved) {
    try { current = JSON.parse(cur.textContent); } catch (e) {}
    if (current && current.h) {
      write([current, ...read().filter((x) => x.h !== current.h)]);
      window.__lbRecentSaved = true;
    }
  }
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  document.querySelectorAll('[data-lb-recent]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const items = read().filter((x) => !current || x.h !== current.h).slice(0, 4);
    if (!items.length) return;
    root.querySelector('[data-lb-recent-list]').innerHTML = items.map((x) =>
      `<li><a href="${esc(x.u)}"><img src="${esc(x.i)}" alt="" width="400" height="400" loading="lazy"><span><b>${esc(x.t)}</b><small>${esc(x.p)}</small></span></a></li>`).join('');
    root.hidden = false;
    root.querySelector('[data-lb-recent-clear]').addEventListener('click', () => { try { localStorage.removeItem(KEY); } catch (e) {} root.hidden = true; });
  });
})();
